import { useEffect, useState } from "react";
import NotificationService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import { trace } from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/Logging";
import Badge from "../models/Badge";
import BadgeService from "../services/BadgeService";

export const useBadgeList = () => {
  const [search, setSearch] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedBadge, setSelectedBadge] = useState<Badge | undefined>(undefined);

  const [viewBadge, setViewBadge] = useState<Badge | undefined>();
  const [editBadge, setEditBadge] = useState<Badge | undefined>();
  const [editMode, setEditMode] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [result, setResult] = useState<number>();

  const handleOpenViewDialog = (instance: Badge) => {
    setViewBadge(instance);
    setDisabled(true);
  };

  const handleCloseDialog = () => {
    setViewBadge(undefined);
    setDisabled(false);
  };

  const handleOpenEditDialog = (badge: Badge) => {
    setEditBadge(badge);
    setEditMode(true);
  };

  const handleOnDeleteBadge = async () => {
    if (!selectedBadge) return;
    setIsLoading(true);
    try {
      await BadgeService.delete(selectedBadge);

      setSelectedBadge(undefined);
      NotificationService.info("Badge deleted successfully");
    } catch (error) {
      NotificationService.error("Error trying to delete badge");
    }
    setIsLoading(false);
  };

  const handleOpenChangeStatusDialog = async (selectedBadge: Badge) => {
    if (!selectedBadge) return;
  };

  return {
    badgeActions: {
      setSearch,
      setIsLoading,
      setEditMode,
      setSelectedBadge,
      handleOpenViewDialog,
      handleCloseDialog,
      setViewBadge,
      handleOnDeleteBadge,
      handleOpenEditDialog,
      setEditBadge,
      handleOpenChangeStatusDialog,
    },
    badgeItems: {
      selectedBadge,
      search,
      editMode,
      disabled,
      viewBadge,
      editBadge,
    },
    isLoading,
    setIsLoading,
  };
};
